import HowItWorksSection from './HowItWorksSection';

export default HowItWorksSection;
